<template>
  <el-dialog
  :visible="show"
  width="50%"
  :close-on-click-modal="false"
  :close-on-press-escape="false"
  :show-close="false">
    <div slot="title">{{ type === 1 ? '使用协议' : '隐私政策' }}</div>
    <div class="privacy-container">
      <!-- 使用协议 -->
      <div class="agreement-section" v-if="type === 1">
        <div>
					<div class='item-title'>一、服务协议的确定</div>
					<p>《服务条款》（以下简称"本条款"）由北京品诺优创科技有限公司在提供域名为www.pinuc.com品诺网的网站服务时与品诺网用户达成的关于使用品诺网的各项规则、条款和条件。用户点击"同意"选项完成注册，这表示用户已接受本服务条款，并与公司就本服务条款达成协议。</p>
			</div>
			<div>
					<div class='item-title'>二、内容所有权</div>
					<p>1、品诺网提供的网络服务内容可能包括：文字、软件、声音、图片、录象、图表等。所有这些内容受版权、商标和其它财产所有权法律的保护。</p>
					<p>2、用户只有在获得品诺网或其他相关权利人的授权之后才能使用这些内容，而不能擅自复制、再造这些内容、或创造与这些内容有关的派生产品。</p>
			</div>
			<div>
					<div class='item-title'>三、用户信息的提供</div>
					<p>为保障用户的合法权益，避免在服务时因用户注册资料与真实情况不符而发生纠纷，请用户注册时务必按照真实、全面、准确的原则填写。对因用户自身原因而造成的不能服务情况，用户需承担相应责任。如果用户提供的资料包含有不正确的信息，品诺网保留结束该用户使用服务资格的权利。</p>
			</div>
			<div>
					<div class='item-title'>四、用户资料隐私保护</div>
					<p> 1、本协议所称之用户隐私包括被法律确认为隐私内容，并符合下述范围的信息：</p>
					<p>(a) 用户注册品诺网时根据网站要求提供的个人信息；</p>
					<p>(b) 在用户使用品诺网服务、参加网站活动、或访问网站网页时，网站自动接收并记录的用户浏览器上的服务器数据，包括但不限于IP地址、网站Cookie中的资料及用户要求取用的网页记录；</p>
					<p>(c) 品诺网通过合法途径从商业伙伴处取得的用户个人资料。</p>
					<p>2、保护用户隐私是品诺网的一项基本政策，品诺网保证不对外公开或向第三方提供用户注册资料及用户在使用网络服务时存储在品诺网的非公开内容，但下列情况除外：</p>
					<p>(a) 事先获得用户的明确授权；</p>
					<p>(b) 根据有关的法律法规要求；</p>
					<p>(c) 按照相关政府主管部门的要求；</p>
					<p>(d) 为维护社会公众的利益；</p>
					<p>(e) 为维护品诺网的合法权益。</p>
					<p>3、品诺网可能会与第三方合作向用户提供相关服务，在此情况下，如该第三方同意承担与品诺网同等的保护用户隐私的责任，则品诺网可将用户的注册资料等信息提供给该第三方。</p>
					<p>4、在不透露单个用户隐私资料的前提下，品诺网有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。</p>
					<p>5、用户须做到</p>
					<p>(a) 用户名和昵称的注册与使用应符合网络道德，遵守中华人民共和国的相关法律法规；</p>
					<p>(b) 用户名和昵称中不能含有威胁、淫秽、漫骂、非法、侵害他人权益等有争议性的文字。</p>
			</div>
			<div>
					<div class='item-title'>五、用户资料安全</div>
					<p>1、对用户注册信息品诺网提供最大限度的安全保障。同时，用户务必对其用户密码、个人账号等信息保密，以免被盗用或遭窜改。注册成功后，用户必须保护好自己的账号和密码，对非因品诺网原因的泄露品诺网概不负责。 用户可随时改变自己的密码，也可以结束旧的账户重开一个新账户。用户若发现任何非法使用用户账号或安全漏洞的情况，应当立即与品诺网联系，如因用户自身原因造成其账户无法正常使用及遭受损失，品诺网对此概不负责，一切损失由用户自行承担。</p>
					<p>2、用户不得通过不正当手段恶意注册品诺网账号，不得盗用他人账号，不得泄露其他用户的相关信息。如用户违反上述规定，则品诺网有权直接采取一切必要的措施，包括但不限于删除用户发布的内容、暂停或查封用户账号，取消因违规所获利益，乃至通过诉讼形式追究用户法律责任等。</p>
			</div>

			<div>
					<div class='item-title'>六、用户享有的权利及服务</div>
					<p>1、用户有权随时对自己的个人资料进行查询、修改和删除。</p>
					<p>2、用户理解，品诺网仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如电脑、调制解调器及其他与接入互联网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费）均应由用户自行承担。</p>
					<p>3、用户须对其账户中的所有行为、活动和事件负全责。</p>
			</div>
			<div>
					<div class='item-title'>七、用户管理</div>
					<p>1、用户不得利用本网站危害国家安全、泄露国家秘密，不得侵犯国家社会集体的和公民的合法权益，不得利用本网制作、复制和传播下列信息：</p>
					<p>(a) 煽动抗拒、破坏宪法和法律、行政法规实施的；</p>
					<p>(b) 煽动颠覆国家政权，推翻社会主义制度的；</p>
					<p>(c) 煽动分裂国家、破坏国家统一的；</p>
					<p>(d) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
					<p>(e) 捏造或者歪曲事实，散布谣言，扰乱社会秩序的；</p>
					<p>(f) 宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的；</p>
					<p>(g) 公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的；</p>
					<p>(h) 损害国家机关信誉的；</p>
					<p>(i) 其他违反宪法和法律行政法规的；</p>
					<p>(j) 进行商业广告行为的。</p>
					<p>2、品诺网声明品诺网对用户的系统记录有可能作为用户违反法律的证据。</p>
					<p>3、未经品诺网的授权或许可，任何用户不得借用品诺网的名义从事任何商业活动，也不得将品诺网作为从事商业活动的场所、平台或其他任何形式的媒介。禁止用户将本站用作从事各种非法活动的场所、平台或者其他任何形式的媒介。如用户违反上述规定，则品诺网有权直接采取一切必要的措施，包括但不限于删除用户发布的内容、暂停或查封用户账号，乃至通过诉讼形式追究用户法律责任等。</p>
			</div>
      </div>
      <!-- 隐私政策 -->
      <div class="agreement-section" v-else-if="type === 2" v-html="privacyInfo"></div>

    </div>
    <span slot="footer" class="dialog-footer">
      <a href="javascript:;" @click="handleClose">不同意</a>
      <a :class="{ 'not-allow': countdown > 0 }" href="javascript:;" type="primary" @click="handleConfirm" >同意{{ countdown > 0 ? `(${countdown}s)` : `` }}</a>
    </span>
  </el-dialog>
</template>

<script>
import { privacyHtml } from './textData'
export default {
  name: 'PrivacyPolicyDialog',
  data() {
    return {
      countdown: 0,
      privacyInfo: ''
    }
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    type: {
      type: Number,
      default: 1
    }
  },
  components: {},
  computed: {},
  mounted() {
    this.privacyInfo = privacyHtml
  },
  methods: {
    handleShow() {
      let isRead = window.localStorage.getItem('privacy_show_flag')

      if (!isRead) {
        window.localStorage.setItem('privacy_show_flag', true)

        this.countdown = 5
        this.startCountdown()
      }
    },
    handleClose() {
      this.$emit('handleClose')
    },
    handleConfirm() {
      if (this.countdown > 0) return
      this.$emit('handleConfirm')
    },
    startCountdown() {
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown--
          this.startCountdown()
        }, 1000)
      }
    }
  },
  watch: {
    show(newVal, oldVal) {
      newVal && this.handleShow()
    }
  }
}
</script>

<style lang='scss' scoped>
.privacy-container {
  max-height: 600px;
  overflow-y: auto;
}
.item-title {
  font-weight: bold;
}

.dialog-footer {
  > a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    padding: 12px 20px;
    border-radius: 4px;
    background: #ccc;
    color: #303133;

    & + a {
      margin-left: 12px;
    }

    &[type='primary'] {
      color: #fff;
      background: #f1bd59;
    }
  }

  .not-allow {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
